import { AsideMenuItem } from './aside-menu-item';
import { AsideMenuItemWithSub } from './aside-menu-item-with-sub';
import { Loading } from 'components/loading';
import { useAuth } from 'features/auth/contexts/auth';
import { Page } from 'features/shared/model';

export function AsideMenuSales() {
  const { isGranted, currentPermissions } = useAuth();

  const canReadAppointmentLog = isGranted(Page.AppointmentLog, 'read');
  const canReadTeamDiary = isGranted(Page.TeamDiary, 'read');
  const canReadEnquiryManagement = isGranted(Page.EnquiryManagement, 'read');

  //TODO
  const canReadWorkPatterns = isGranted(Page.WorkPattern, 'read');

  const canSalesExecutor = isGranted(Page.SalesExecutors, 'read');
  const canSalesBranchKPIs = isGranted(Page.BranchKPI, 'read');
  const canReadLeads = isGranted(Page.Leads, 'read');
  const canReadTestDriveLog = isGranted(Page.TestDriveLog, 'read');
  const canReadVehicleStock = isGranted(Page.VehicleStock, 'read');
  const canReadSalesPerfomanceSubMenu = canSalesExecutor;

  return currentPermissions ? (
    <>
      <div className="text-gray-400 mb-7 fs-7 text-uppercase">SALES</div>

      <AsideMenuItemWithSub to="/appointments" title="Appointments" icon="/media/icons/custom/address-book.svg">
        {canReadAppointmentLog && (
          <AsideMenuItem to="/appointments/appointment-log" hasBullet title="Appointment log" />
        )}
        {canReadTeamDiary && <AsideMenuItem to="/appointments/team-diary" hasBullet title="Team Diary" />}
      </AsideMenuItemWithSub>

      <AsideMenuItemWithSub to="/appraisals" title="Appraisal" icon="/media/icons/custom/car.svg">
        {canReadWorkPatterns && <AsideMenuItem to="/appraisals" title="Appraisals" hasBullet />}
      </AsideMenuItemWithSub>

      <AsideMenuItem to="/deals" icon="/media/icons/custom/calculator.svg" title="Deals" />

      {canReadEnquiryManagement && (
        <AsideMenuItem to="/enquiry-manager" icon="/media/icons/custom/abstract-26.svg" title="Enquiry Management" />
      )}

      {canReadLeads && <AsideMenuItem to="/leads" icon="/media/icons/custom/profile-2user.svg" title="Leads" />}

      <AsideMenuItem
        to="/product-presentations"
        icon="/media/icons/custom/product-presentations.svg"
        title="Products Presentations"
      />

      {canReadSalesPerfomanceSubMenu && (
        <AsideMenuItemWithSub
          to="/sales-perfomance"
          title="Sales Perfomance Reports"
          icon="/media/icons/custom/delivery-logistics-red.svg"
        >
          {canSalesBranchKPIs && (
            <>
              <AsideMenuItem to="/sales-perfomance/branches" title="Branches" hasBullet={true} />
              <AsideMenuItem to="/sales-perfomance/sales-branch-kpi" title="Sales Branch KPIs" hasBullet={true} />
              {canSalesExecutor && (
                <AsideMenuItem to="/sales-perfomance/sales-executive" title="Sales Executive" hasBullet={true} />
              )}
              <AsideMenuItem
                to="/sales-perfomance/weekly-sales-team-report"
                title="Weekly Sales Team report"
                hasBullet={true}
              />
            </>
          )}
        </AsideMenuItemWithSub>
      )}

      {canReadTestDriveLog && (
        <AsideMenuItem to="/test-drive-Log" icon="/media/icons/custom/security.svg" title="Test Drive Log" />
      )}

      {canReadVehicleStock && (
        <AsideMenuItem to="/vehicle-stock" icon="/media/icons/custom/security.svg" title="Vehicle Stock" />
      )}

      <AsideMenuItem to="/video-log" icon="/media/icons/custom/youtube.svg" title="Video Log" />

      <AsideMenuItemWithSub
        to="/stock-management"
        title="Stock Management"
        icon="/media/icons/custom/delivery-logistics-red.svg"
      >
        <AsideMenuItem to="/purchase-planner" title="Purchase Planner" hasBullet={true} />
      </AsideMenuItemWithSub>
    </>
  ) : (
    <Loading />
  );
}
